<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="svg-icon">
    <g :fill="fillColor">
      <path
        d="M19,5.25H5A1.76,1.76,0,0,0,3.25,7V17A1.76,1.76,0,0,0,5,18.75H19A1.76,1.76,0,0,0,20.75,17V7A1.76,1.76,0,0,0,19,5.25ZM19.25,7V8.67l-.09,0-.12,0a1.45,1.45,0,0,1-.36,0l-.13,0a1.8,1.8,0,0,1-.33-.1l-.12,0a1.29,1.29,0,0,1-.38-.28,1.58,1.58,0,0,1-.47-1.12,1.45,1.45,0,0,1,.06-.41H19A.25.25,0,0,1,19.25,7ZM5,6.75H6.69a1.45,1.45,0,0,1,.06.41,1.58,1.58,0,0,1-.47,1.12,1.49,1.49,0,0,1-.38.28l-.13,0a1.12,1.12,0,0,1-.31.1l-.14,0a1.45,1.45,0,0,1-.36,0l-.12,0-.09,0V7A.25.25,0,0,1,5,6.75ZM4.75,17V15.33l.09,0,.12,0a1.45,1.45,0,0,1,.36,0l.13,0a1.26,1.26,0,0,1,.33.1l.12,0a1.49,1.49,0,0,1,.38.28,1.58,1.58,0,0,1,.47,1.12,1.45,1.45,0,0,1-.06.41H5A.25.25,0,0,1,4.75,17Zm3.47.25a2.73,2.73,0,0,0,0-.41,3,3,0,0,0-.91-2.18,2.63,2.63,0,0,0-.49-.39l-.17-.11A3.39,3.39,0,0,0,6.29,14l-.2-.08a3.33,3.33,0,0,0-.53-.11,1.56,1.56,0,0,0-.31,0h-.5V10.22H5l.17,0,.17,0,.26,0A2.71,2.71,0,0,0,6,10.12l.22-.07a2.48,2.48,0,0,0,.44-.2l.16-.09a3.42,3.42,0,0,0,.52-.42,3,3,0,0,0,.91-2.18,2.73,2.73,0,0,0,0-.41h7.56a2.73,2.73,0,0,0,0,.41,3,3,0,0,0,.91,2.18,2.9,2.9,0,0,0,.52.42l.16.09a2.48,2.48,0,0,0,.44.2l.22.07a2.71,2.71,0,0,0,.41.09l.26,0,.17,0,.17,0h.24v3.56h-.5a1.62,1.62,0,0,0-.31,0,3.33,3.33,0,0,0-.53.11l-.2.08a3.39,3.39,0,0,0-.39.18l-.17.11a2.63,2.63,0,0,0-.49.39,3,3,0,0,0-.91,2.18,2.73,2.73,0,0,0,0,.41Zm10.78,0H17.31a1.45,1.45,0,0,1-.06-.41,1.58,1.58,0,0,1,.47-1.12,1.29,1.29,0,0,1,.38-.28l.12,0a2.07,2.07,0,0,1,.33-.1l.13,0a1.45,1.45,0,0,1,.36,0l.12,0,.09,0V17A.25.25,0,0,1,19,17.25Z"
      />
      <path
        d="M12,8.5A3.5,3.5,0,1,0,15.5,12,3.5,3.5,0,0,0,12,8.5ZM12,14a2,2,0,1,1,2-2A2,2,0,0,1,12,14Z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    fillColor: {
      type: String,
      required: false,
    },
  },
};
</script>
